import React from 'react';
import styles from "./transactionsHeader.scss";
import classNames from 'classnames/bind';
import Dropdown from '../../../components/common/material/DropDown';
import ReactModal from 'react-modal';
import {Link} from "react-router";
import PropTypes from "prop-types";
import {injectIntl} from "react-intl";
import {FileFormat} from "../../../services/api/dto/fileFormat";
// Des : title   -   DD   -  small title


@injectIntl
class TransactionsHeader extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      isViewStatementModalOpen: false
    };
  }

  static propTypes = {
    title: PropTypes.string,
    optionalDdData: PropTypes.array,
    onRightTitleClick: PropTypes.func,
    ddOnChange: PropTypes.func,
    pickedTransactionDd: PropTypes.number,
    rightTitle: PropTypes.string,
    placeHolderDd: PropTypes.string,
    statementsUrl: PropTypes.array,
    isPickedTransaction: PropTypes.bool,
    intl: PropTypes.object
  };


  render() {
    const {title, optionalDdData, onRightTitleClick, ddOnChange, pickedTransactionDd,
      rightTitle, placeHolderDd, statementsUrl, isPickedTransaction} = this.props;
    const {
      intl: { formatMessage }
    } = this.props;

    const cx = classNames.bind(styles); // take the classes style property's from styles
    const theme = {
      values: styles.nextTransactionDropDownValues
    };

    const onRightTitleClickHandler = (event) => {
      onRightTitleClick();
      openStatementModal();
      event.stopPropagation();
    };
    const transactionPlaceHolderDd = pickedTransactionDd === null ? placeHolderDd : '';

    const openStatementModal = () => {
      this.setState((prevState) => {
        return {
          ...prevState,
          isViewStatementModalOpen: true,
        };
      });
    };

    const closeStatementModal = () => {
      this.setState((prevState) => {
        return {
          ...prevState,
          isViewStatementModalOpen: false,
        };
      });
    };

    return (
      <div className={cx('transactions-container')}>

        <div className={cx('transactions')}>
          <header className={cx('header')}>
            <h1 className={cx('title')}
                data-at={`transactions-header ${(title || "").replace(" ", "-")}`}>
              {title}
            </h1>
          </header>
        </div>

        {(optionalDdData != null && optionalDdData.length) > 0 &&
          <div className={cx('drop-down-container')}>
            <Dropdown className={cx('transaction-drop-down')}
                      data-at="transaction-drop-down"
                      theme={theme}
                      auto={false}
                      value={pickedTransactionDd}
                      onChange={ddOnChange}
                      label={transactionPlaceHolderDd}
                      source={optionalDdData}/>
          </div>}

        {rightTitle !== "" &&
          <div className={cx('right-title-container')}>
            <div>
              <header className={cx('transaction-header-container-logo')}
                      onClick={onRightTitleClickHandler}>
                <h1 className={cx('title')}
                    data-at={`transactions-header ${(rightTitle || "").replace(" ", "-")}`}>
                  {rightTitle}
                </h1>
              </header>
            </div>
          </div>}
        <ReactModal isOpen={this.state.isViewStatementModalOpen}
                    ariaHideApp={false}
                    style={{
                      overlay: {background: 'rgba(17, 28, 53, 0.5)'},
                      content: {
                        textAlign: 'center', top: '50%', left: '50%', right: 'auto', bottom: 'auto',
                        transform: 'translate(-50%, -50%)', borderRadius: '15px', padding: 20,
                        midWidth: '350px'
                      }
                    }}>
          <div className={cx("statement-modal-container")}>
            <div className={cx("close-img-container")}>
              <img src={'/static/icons/close-grey.svg'} onClick={() => closeStatementModal()}/>
            </div>
            {optionalDdData && optionalDdData[pickedTransactionDd] &&  <div style={{display: 'flex', justifyContent: 'center'}}>
              <div className={cx("modal-header")}>
                {formatMessage({id: 'card.statement.downloadStatement'})}
                <br/>
                {optionalDdData[pickedTransactionDd].label}
              </div>
            </div>}
            {statementsUrl && statementsUrl.map((statementUrl, index) =>
              statementUrl.visible && (
                <div key={index} className={cx('view-options-container')}>
                  <h2 className={cx('title')}>View As {statementUrl.fileFormat}</h2>
                  <div className={cx("links-container")}>
                    {isPickedTransaction && <Link target="_blank"
                                                  data-at="transaction-header-link"
                                                  to={statementUrl.url + `${statementUrl.fileFormat === FileFormat.PDF ? '?statementOnly=true' : ''}`}>
                      <img src={'/static/icons/download.svg'} className={cx('img-icon')}/>
                      {formatMessage({id: 'card.statement.statement'})}
                    </Link>}
                  </div>
                </div>
              )
            )}

          </div>
        </ReactModal>
      </div>
    );
  }
}

export default TransactionsHeader;



// WEBPACK FOOTER //
// ./src/card/transaction/transactionsHeader/transactionsHeader.js